import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { API_POST } from '../../services';
import { ErrorResponse } from '../../utils/errorUtils';
import { env } from '../../env';
import { ENDPOINTS } from '../../constants/endPoints';
import { ClickLogPayload } from '../../models/UsageMetricsModel';

type UsageMetricsState = Record<string, never>;

const initialState: UsageMetricsState = {};

export const logClickEvent = createAsyncThunk<void, ClickLogPayload>(
  'usageMetrics/logClickEvent',
  async (payload: ClickLogPayload) => {
    try {
      // Once deployed the APIM subscription key is passed back via RetrieveUserDetails
      // When running locally developers can set their APIM subscription key in the mock UserModel
      // If developers want to test the function app directly (without middle man APIM) then they must instead pass the x-functions-key in the header
      const subscriptionKey = payload.apimSubscriptionKey || env.APIM_SUBSCRIPTION_KEY || '';

      const headers: Record<string, string> = {};
      if (subscriptionKey) {
        headers['Ocp-Apim-Subscription-Key'] = subscriptionKey;
      }

      await API_POST(`${env.RAD_FUNCTION_APP_URL}${ENDPOINTS.LOG_CLICK_EVENT}`, payload, headers);
    } catch (error: unknown) {
      const errorResponse = error as ErrorResponse;
      // Silent fail - log for monitoring but don't show user error dialog
      console.error('[RADUsageMetrics] Failed to log click event', {
        error: errorResponse,
        payload,
      });
    }
  },
);

const usageMetricsSlice = createSlice({
  name: 'usageMetrics',
  initialState,
  reducers: {},
});

export default usageMetricsSlice.reducer;
